module.exports = __webpack_public_path__ + "image/PER_logo1.png";